'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; /**
                     * This is adapted from Facebook's ReactCSSTransitionGroup which is in the React
                     * addons and under the BSD License.
                     */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsTransitionGroup = require('react-addons-transition-group');

var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);

var _validateTransitionProp = require('./validateTransitionProp');

var _validateTransitionProp2 = _interopRequireDefault(_validateTransitionProp);

var _CustomCSSTransitionGroupChild = require('./CustomCSSTransitionGroupChild');

var _CustomCSSTransitionGroupChild2 = _interopRequireDefault(_CustomCSSTransitionGroupChild);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomCSSTransitionGroup = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(CustomCSSTransitionGroup, _Component);

  function CustomCSSTransitionGroup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CustomCSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CustomCSSTransitionGroup.__proto__ || (0, _getPrototypeOf2.default)(CustomCSSTransitionGroup)).call.apply(_ref, [this].concat(args))), _this), _this._wrapChild = function (child) {
      var _this2 = _this,
          props = _this2.props;


      return _react2.default.createElement(
        _CustomCSSTransitionGroupChild2.default,
        {
          name: props.transitionName,
          appear: props.transitionAppearTimeout !== false ? props.transitionAppearTimeout : false,
          enter: props.transitionEnterTimeout !== false ? props.transitionEnterTimeout : false,
          leave: props.transitionLeaveTimeout !== false ? props.transitionLeaveTimeout : false,

          afterAppear: props.afterAppear,
          afterEnter: props.afterEnter,
          afterLeave: props.afterLeave
        },
        child
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CustomCSSTransitionGroup, [{
    key: 'render',
    value: function render() {
      // remove warning for unused vars / missing proptype definition
      /* eslint no-unused-vars: 0, react/prop-types: 0 */
      var _props = this.props,
          afterEnter = _props.afterEnter,
          afterLeave = _props.afterLeave,
          animating = _props.animating,
          rest = (0, _objectWithoutProperties3.default)(_props, ['afterEnter', 'afterLeave', 'animating']);

      return _react2.default.createElement(_reactAddonsTransitionGroup2.default, (0, _extends3.default)({}, rest, { childFactory: this._wrapChild }));
    }
  }]);
  return CustomCSSTransitionGroup;
}(_react.Component), _class.displayName = 'CustomCSSTransitionGroup', _class.propTypes = {
  transitionName: _CustomCSSTransitionGroupChild2.default.propTypes.name,

  transitionAppearTimeout: _validateTransitionProp2.default,
  transitionEnterTimeout: _validateTransitionProp2.default,
  transitionLeaveTimeout: _validateTransitionProp2.default,

  afterAppear: _react.PropTypes.func,
  afterEnter: _react.PropTypes.func,
  afterLeave: _react.PropTypes.func
}, _class.defaultProps = {
  transitionAppearTimeout: false,
  transitionEnterTimeout: 1000,
  transitionLeaveTimeout: 1000
}, _temp2);
exports.default = CustomCSSTransitionGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/CustomCSSTransitionGroup/CustomCSSTransitionGroup.jsx
// module id = 1648
// module chunks = 0